var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-contain",class:_vm.language == 'zh_CN' ? '' : 'page-contain-us'},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"download-contain"},[_c('img',{staticClass:"bg-img",attrs:{"src":require("@/assets/lekang1.jpg"),"alt":"culture"}})])
}]

export { render, staticRenderFns }